module.exports = __webpack_public_path__ + "img/default_perio_img.d4076a32.png";